import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { AppState } from '../../../store';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';

import Link from '../../elements/link';
import { Card, CardActionButton, TableNew, Button, ComponentModesEnum } from '../../elements';
import { CONSTS } from '../../elements/_constants';
import { fetchCommodities, deleteCommodity } from '../../../store/commodities/functions';
import { Commodity } from '../../../store/commodities/types';
type CommoditiesListComponentProps = {
    className?: string,
    match: any,
    commodities: any,
    onFetchCommodities: Function,
    onDeleteCommodity: Function
}
const CommoditiesListComponent = (props: CommoditiesListComponentProps) => {
    const [deleted, setDeleted] = useState(false);
    useEffect(() => {
        try {
            props.onFetchCommodities();
        } catch (error) {
            console.log(error);
        }
        return () => { };
    }, [deleted])
    const columns: any[] = [
        {
            title: "نام",
            dataIndex: "name"
        },
        {
            title: "شرکت",
            dataIndex: "company"
        },
        {
            title: "موجودی",
            dataIndex: "trans_stock"
        },
        {
            title: "نقطه سفارش",
            dataIndex: "order_point"
        },
        {
            title: '',
            dataIndex: 'id',
            style: { width: 100 },
            render: (id: number) => (
                <>
                    <Button onClick={() => hanleDelete(id)} style={{ background: 'none', padding: 0, color: 'red', marginLeft: 10 }} >حذف</Button>
                    <Link style={{ color: CONSTS.colors.greyDarker }} to={`/commodities/${id}/edit`}>ویرایش</Link>
                </>
            )
        }
    ];

    const tableOptions = {
        rowStyle: (com: Commodity) => {
            var diff = com.trans_stock - com.order_point;
            if (diff < 0)
                return { backgroundColor: 'rgba(255, 134, 125, .1)', color: 'red', fontWeight: 500 }
            else if (diff <= (com.order_point/2) )
                return { backgroundColor: 'rgba(255, 247, 0, .3)' }
        }
    }

    const hanleDelete = (id: number) => {
        if (!window.confirm('از حذف این مورد اطمینان دارید؟')) return;
        props.onDeleteCommodity(id, () => {
            setDeleted(!deleted);
        });
    }

    return (
        <div className={props.className}>
            <Card
                title={"لیست کالاها"}
                headerMeta={<>
                    <CardActionButton title="ثبت ورود/خروج" to={`/store/transactions/new`} hasBorderRight={true} />
                    <CardActionButton title="ایجاد کالای جدید" to={`/commodities/new`} iconClassName="icon-icons8-plus_math" hasBorderRight={true} />
                </>}
            >
                <div style={{ padding: 25 }}>
                    {props.commodities && <TableNew dataSource={props.commodities} columns={columns} options={tableOptions} />}
                </div>
            </Card>
        </div>
    )
}
const CommoditiesList = styled(CommoditiesListComponent)`
  /* padding-left: 29px; */
  @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
    padding-left: 15px;
  }
`

const mapStateToProps = (state: AppState, ownProps: any) => ({
    commodities: state.commodities.items,
});

const mapDispatchToProps = (dispatch: any) => {
    return {
        onFetchCommodities: () => {
            dispatch(fetchCommodities());
        },
        onDeleteCommodity: (id: number, then?: Function) => {
            dispatch(deleteCommodity(id, then));
        }
    };
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(CommoditiesList));